/**
 * Keepix Main Entry Point
 *
 * This file is the main entry point for Vite bundling.
 * It imports all third-party dependencies and custom code.
 */

// ============================================================================
// CSS Imports
// ============================================================================
import './main.css';

// ============================================================================
// Third-Party CSS
// ============================================================================
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'toastr/build/toastr.min.css';
import 'bootstrap-select/dist/css/bootstrap-select.min.css';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.css';
import 'photoswipe/dist/photoswipe.css';
import 'photoswipe-dynamic-caption-plugin/photoswipe-dynamic-caption-plugin.css';

// ============================================================================
// jQuery and jQuery UI (needed for legacy code and plugins)
// ============================================================================
import $ from 'jquery';
// jQuery UI has issues with ES module imports, load via script tag in template for now
// import 'jquery-ui-dist/jquery-ui.min.js';

// Make jQuery available globally for legacy code
window.$ = window.jQuery = $;

// ============================================================================
// Bootstrap JavaScript
// ============================================================================
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// ============================================================================
// Knockout.js
// ============================================================================
import ko from 'knockout';
window.ko = ko; // Make available globally

// ============================================================================
// Bootstrap Plugins
// ============================================================================
import 'bootstrap-select/dist/js/bootstrap-select.min.js';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.js';

// ============================================================================
// Toastr Notifications
// ============================================================================
import toastr from 'toastr';
window.toastr = toastr; // Make available globally

// ============================================================================
// Numeral.js (number formatting)
// ============================================================================
import numeral from 'numeral';
window.numeral = numeral; // Make available globally

// ============================================================================
// Moment.js (date/time)
// ============================================================================
import moment from 'moment';
window.moment = moment; // Make available globally

// ============================================================================
// PhotoSwipe 5.x (image gallery)
// ============================================================================
import PhotoSwipe from 'photoswipe';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin';

window.PhotoSwipe = PhotoSwipe;
window.PhotoSwipeLightbox = PhotoSwipeLightbox;
window.PhotoSwipeDynamicCaption = PhotoSwipeDynamicCaption;

// ============================================================================
// Pager.js (vendor file - legacy routing)
// ============================================================================
// This is a legacy vendor file that's not in npm
// We'll need to handle this separately or find npm equivalent
// For now, it will be loaded separately in the template

// ============================================================================
// Custom JavaScript Utilities
// ============================================================================
// These files currently don't use ES modules, so we load them as legacy scripts
// They're still loaded via <script> tags in templates, but we need to copy them
// to dist/ so they're available. We'll handle this via Vite's static copy plugin.

// ============================================================================
// ViewModels
// ============================================================================
// ViewModels are still loaded via <script> tags per-page in templates
// They'll be copied to dist/ via static copy plugin for development workflow

// ============================================================================
// Initialization
// ============================================================================
console.log('Keepix main.js loaded via Vite');
console.log('Vite HMR enabled:', import.meta.hot ? 'Yes' : 'No');

// Hot Module Replacement (HMR) for development
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('Keepix main.js hot reloaded');
  });
}
